import { useCallback } from "react";
import cookiesProvider from "../providers/cookies-provider";
import axios from "axios";
import { getApiUrl } from "./urls";

export function useUploadHook() {
    const apiUrl = getApiUrl()
    const uploadFile = useCallback(async (file, resource) => {
        const token = await cookiesProvider.getToken();
        const cfg = {
            headers: { Authorization: `Bearer ${token}` },
            "Content-Type": "multipart/form-data",
            'Access-Control-Allow-Origin': 'https://app.juristta.com'
        }
        let fd = new FormData()
        fd.append("resource", resource)
        fd.append("files", file)

        const res = await axios.post(`${apiUrl}/attachments/upload`, fd, cfg);
        if (res.status === 201 && res.data) {
            return res.data;
        }
        throw new Error(res.data);
    }, [apiUrl])

    return {
        uploadFile
    }
}